import { cn } from '@/lib/utils';
import type { EstadoMovimiento, EstadoDistribucion } from '@/contabilidad/types';
import {
  ESTADO_MOVIMIENTO_STYLES,
  ESTADO_INGRESO_STYLES,
  ESTADO_EGRESO_STYLES,
  ESTADO_DISTRIBUCION_STYLES,
} from '@/contabilidad/constants/styles';
import type { EstadoIngreso, EstadoEgreso } from '@/contabilidad/constants/styles';

type AnyEstado = EstadoMovimiento | EstadoIngreso | EstadoEgreso | EstadoDistribucion;

const ALL_STYLES: Record<string, { bg: string; text: string; dot: string }> = {
  ...ESTADO_MOVIMIENTO_STYLES,
  ...ESTADO_INGRESO_STYLES,
  ...ESTADO_EGRESO_STYLES,
  ...ESTADO_DISTRIBUCION_STYLES,
};

interface EstadoBadgeProps {
  estado: AnyEstado | string;
  className?: string;
}

export function EstadoBadge({ estado, className }: EstadoBadgeProps) {
  const style = ALL_STYLES[estado] ?? { bg: 'bg-gray-100', text: 'text-gray-600', dot: 'bg-gray-400' };

  return (
    <span className={cn('inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-semibold', style.bg, style.text, className)}>
      <span className={cn('size-1.5 rounded-full', style.dot)} />
      {estado}
    </span>
  );
}
